import { render, staticRenderFns } from "./staffDetail.vue?vue&type=template&id=0b593a68&scoped=true&"
import script from "./staffDetail.vue?vue&type=script&lang=js&"
export * from "./staffDetail.vue?vue&type=script&lang=js&"
import style0 from "./staffDetail.vue?vue&type=style&index=0&id=0b593a68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b593a68",
  null
  
)

export default component.exports